export const getPosVersion = () => {
  let version = /PV=(.*?)(?=;|$)/.exec(document.cookie);
  if (version) {
    return version[1];
  } else {
    return '';
  }
};

/**
 * 判断pos版本
 * @param {String} version 版本号 （只传版本默认大于等于）
 * @param {String} checkType 大于或小于 ('before', 'after')
 * @param {Boolean} includeEqual 是否包括等于
 * @returns {boolean}
 */
export const checkPosVersion = (version, checkType = 'after', includeEqual = true) => {
  let type, result = false;
  let currentVersion = getPosVersion();
  version = version.toString();
  if (checkType === 'after') {
    type = true;
  } else if (checkType === 'before') {
    type = false;
  } else {
    console.error(`use 'before' or 'after' in the second param`);
  }
  if (!currentVersion) {
    // 未登录pos，版本为空
    return false;
  }
  if (includeEqual) {
    result = type ? currentVersion >= version : currentVersion <= version;
  } else {
    result = type ? currentVersion > version : currentVersion < version;
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/utils/posVersion.js